module.exports = __webpack_public_path__ + "img/shrink.02f8f867.svg";